import { Skeleton } from "antd";

export function ThreadListItemSkeleton() {
  return (
    <div className="w-full">
      <Skeleton.Node
        active
        className="block! w-full! h-auto! aspect-video! rounded-xl!"
      />
      <Skeleton.Node
        active
        className="block! w-11/12! h-5! mt-3! rounded-md!"
      />
      <Skeleton.Node active className="block! w-1/2! h-5! mt-1! rounded-md!" />
    </div>
  );
}
